import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { LeadActivityService } from 'src/app/private/services/lead-activity.service';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.scss']
})
export class AddTaskComponent {

  @Output() close = new EventEmitter<void>();
  btnLoading = false;
  today: string = '';
  minDateTime: string = '';
  @Input() editFieldValues: any;
  @Output() reload = new EventEmitter<void>();
  @Input() editTaskData: any;
  @Input() type = 'Add';
  users:any = [];

  constructor(private toaster: ToastrService,
    private api: LeadService,
    private localstorage: LocalStorageService,
     private userApi: UsersService,
     private tracker: TrackingService,
     private leadActivity: LeadActivityService
  ) { }
  openCalendar(event: any) {
  event.target.showPicker?.(); // Chrome / Edge
}
  closeModal() {
    this.close.emit();
  }

  ngOnInit() {
    console.log("editFieldValues", this.editFieldValues);
    const currentDate = new Date();
    this.today = this.formatLocalDate(currentDate);
    this.minDateTime = this.formatLocalDateTime(currentDate);


    if (this.type === 'Update') {
      this.taskFormData.title = this.editTaskData.title;
      this.taskFormData.due_date = this.editTaskData.due_date;
      this.taskFormData.reminder = this.editTaskData.reminder;
      this.taskFormData.description = this.editTaskData.description;
      this.taskFormData.repeat = this.editTaskData.repeat;
      this.taskFormData.reminder_data.datetime = this.convertApiDateToLocalInput(this.editTaskData.reminder_data.datetime);
      this.taskFormData.priority = this.editTaskData.priority;
      this.taskFormData.status = this.editTaskData.status;
      this.taskFormData.user_id = this.editTaskData.user_id;
    }
    this.getAllUsers();
  }

  taskFormData = {
    title: '',
    due_date: '',
    reminder: false,
    description: '',
    repeat: false,
    reminder_data: {
      datetime: '',
    },
    repeat_data: null,
    priority: '',
    status: '',
    user_id: this.localstorage.getUserId(),
  };

  isSubmitted = false;
 getAllUsers() {
    let param = {
      client_id: this.localstorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }
  private formatLocalDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private formatLocalDateTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${this.formatLocalDate(date)}T${hours}:${minutes}`;
  }

  isPastDateTime(localDateTime: string): boolean {
    if (!localDateTime) {
      return false;
    }
    return new Date(localDateTime).getTime() < Date.now();
  }

  formatDateForApi(localDateTime: string): string {

    if (!localDateTime) {
      return '';
    }

    const date = new Date(localDateTime);
  
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  
    return `${year}-${month}-${day}T${hours}:${minutes}+00:00`;
  }

  convertApiDateToLocalInput(apiDate: string): string {

    if (!apiDate) {
      return '';
    }

    const date = new Date(apiDate); // parses "2025-04-22T10:45+00:00"
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${year}-${month}-${day}T${hours}:${minutes}`; // perfect for input
  }

  submitTaskForm() {
    this.isSubmitted = true;

    if (this.taskFormData.reminder && !this.taskFormData.reminder_data.datetime) {
      this.toaster.error('Please select reminder date and time');
      return;
    }

    if (this.taskFormData.reminder && this.isPastDateTime(this.taskFormData.reminder_data.datetime)) {
      this.toaster.error('Reminder date and time cannot be in the past');
      return;
    }

    if (
      this.taskFormData.title &&
      this.taskFormData.priority &&
      this.taskFormData.status 
    ) {

      const payload :any= {
        lead_id: this.editFieldValues.lead_id,
        user_id: this.taskFormData.user_id,
        title: this.taskFormData.title,
        client_id: this.localstorage.getClientId(),
        center_id: this.localstorage.getCenterId(),
        due_date: this.taskFormData.due_date,
        reminder: this.taskFormData.reminder,
        description: this.taskFormData.description,
        repeat: this.taskFormData.repeat,
        reminder_data: {
          datetime: this.formatDateForApi(this.taskFormData.reminder_data.datetime),
        },
        repeat_data: null,
        priority: this.taskFormData.priority,
        status: this.taskFormData.status
      };


      this.btnLoading = true;

      if (this.type === 'Update') {
        payload['task_id'] = this.editTaskData.task_id;
        this.api.updateTask(payload).subscribe({
          next: (res) => {
            this.toaster.success('Task updated successfully');
              // ✅ TRACKING
          const desc = `Task updated: ${payload.title} for Lead ID: ${payload.lead_id}`;
          this.tracker.track('Update', 'Task', desc);
            this.btnLoading = false;
            this.reload.emit();
            this.closeModal();
          },
          error: (err) => {
            this.toaster.error(err.error.message || 'Something went wrong');
            this.btnLoading = false;
          }
        });

      } else {


        this.api.addTask(payload).subscribe({
          next: (res) => {
            this.toaster.success('Task created successfully');
             // ✅ TRACKING
          const desc = `Task created: ${payload.title} for Lead ID: ${payload.lead_id}`;
          this.tracker.track('Create', 'Task', desc);
            const taskId = res?.task_id ?? res?.id;
            const finish = () => {
              this.btnLoading = false;
              this.reload.emit();
              this.closeModal();
            };
            if (taskId) {
              this.leadActivity
                .recordTaskCreated(payload.lead_id, taskId, payload.title, res?.status)
                .subscribe({ next: finish, error: finish });
            } else {
              finish();
            }
          },
          error: (err) => {
            this.toaster.error(err.error.message || 'Something went wrong');
            this.btnLoading = false;
          }
        });
      }


    } else {
      this.toaster.error('Please fill all required fields');
    }
  }

}
